module.exports = __webpack_public_path__ + "img/home_mashangjijian_hover.5634e4b.png";